module.exports = __webpack_public_path__ + "media/images/s2ep8-cindy-6a54d1582e8cef107d1f410637eb1870.png";